import _extends from "@babel/runtime/helpers/extends";
import classnames from "classnames/dedupe";
import PropTypes from "prop-types";
import React from "react";
export const THEME_ERROR = "error";
export const THEME_WARNING = "warning";
export const THEME_SUCCESS = "success";
export const Alert = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {any} props.children
 * @param {THEME_ERROR|THEME_WARNING|THEME_SUCCESS} props.theme
 * @param {any} props.className
 * @param {() => any} props.onClick
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Alert({
  children,
  theme = THEME_WARNING,
  className,
  onClick,
  ...props
}, ref) {
  const alertClasses = classnames("alert w-full block z-20 fixed top-0 left-0 py-8 text-center font-gotham font-bold", {
    "alert-error bg-en-red text-white": theme === THEME_ERROR,
    "alert-warning bg-en-yellow-300 text-en-gray-900": theme === THEME_WARNING,
    "alert-success bg-en-green text-white": theme === THEME_SUCCESS
  }, className);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: alertClasses,
    onClick: onClick,
    ref: ref
  }), children);
});
Alert.propTypes = {
  // @ts-ignore
  theme: PropTypes.oneOf([THEME_ERROR, THEME_WARNING, THEME_SUCCESS]),
  className: PropTypes.any,
  children: PropTypes.any,
  onClick: PropTypes.func
};